import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/caprock_merchant.png'
import _imports_1 from '../assets/caprock/images/menu-logout.svg'


const _withScopeId = n => (_pushScopeId("data-v-7af1b150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky" }
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-light" }
const _hoisted_3 = { class: "navbar-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  onclick: "location.href='https://caprock.com.au'"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    onclick: "location.href='https://caprock.com.au'",
    src: _imports_0,
    class: "img-fluid",
    style: {"display":"inline","height":"50px"}
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "d-block",
  src: _imports_1
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.load_on==1)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.token)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                title: "Logout",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.logout();}),
                class: "closefriend-header-top-btn-wrapper"
              }, [
                _createElementVNode("a", {
                  style: {"border":"none","background":"none","color":"white","cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
                }, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}